import React from 'react';
import Button from '../components/Button';
import type { BrandAndProductProps } from '../components/ExternalBrandLogo';
import ExternalBrandLogo from '../components/ExternalBrandLogo';

interface ExternalBrandButtonProps {
  children: React.ReactNode;
  icon: BrandAndProductProps;
  to: string;
}

const ExternalBrandButton = ({
  children,
  icon,
  to,
}: ExternalBrandButtonProps) => (
  <Button
    icon={<ExternalBrandLogo {...icon} height={16} />}
    size="large"
    to={to}
    variant="secondary"
  >
    {children}
  </Button>
);

export default ExternalBrandButton;
